export const CURRENCY_OPTIONS = [
  { value: "EUR", label: "EUR - Euro" },
  { value: "USD", label: "USD - US Dollar" },
  { value: "GBP", label: "GBP - British Pound" },
  { value: "CHF", label: "CHF - Swiss Franc" },
  { value: "AUD", label: "AUD - Australian Dollar" },
  { value: "CAD", label: "CAD - Canadian Dollar" },
];

export const TRIP_TYPES = {
  AIRPORT_PICKUP: "airport_pickup",
  AIRPORT_DROPOFF: "airport_dropoff",
};

export const TRIP_TYPE_LABELS = {
  [TRIP_TYPES.AIRPORT_PICKUP]: "Airport Pickup",
  [TRIP_TYPES.AIRPORT_DROPOFF]: "Airport Drop-off",
};

export const isAirportPickup = (tripType) =>
  tripType === TRIP_TYPES.AIRPORT_PICKUP;

export const validateForm = (values) => {
  const errors = {};

  if (!values.cityId || !values.cityName) {
    errors.cityId = "City is required.";
    return errors;
  }

  if (!values.pickup?.name) {
    errors.pickup = "Pickup location is required.";
  }

  if (!values.dropoff?.name) {
    errors.dropoff = "Drop-off location is required.";
  }

  if (!values.currency) {
    errors.currency = "Currency is required.";
  }

  const passengers = parseInt(values.passengerCount, 10);
  if (!passengers || passengers < 1) {
    errors.passengerCount = "Passenger count must be at least 1.";
  }

  if (isAirportPickup(values.tripType)) {
    if (!values.flightNumber?.trim()) {
      errors.flightNumber = "Flight number is required.";
    }

    if (!values.date) {
      errors.date = "Pickup date is required.";
    }
  } else {
    if (!values.dateTime) {
      errors.dateTime = "Pickup date & time is required.";
    }
  }

  return errors;
};

const formatDateTime = (dateTime) => {
  if (!dateTime) {
    return "—";
  }
  try {
    return new Date(dateTime.replace(" ", "T")).toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return dateTime;
  }
};

export const transformRateAnalysisResponse = (response) => {
  if (!response?.data) {
    return null;
  }

  const { data } = response;
  const fleetOffers = (data.fleetOffers || []).map((offer) => {
    const availableRates = [...(offer.availableRates || [])].sort(
      (a, b) => a.price - b.price
    );

    return {
      ...offer,
      availableRates,
      displayPriceFrom:
        availableRates[0]?.price ?? offer.displayPriceFrom ?? 0,
      offerKey: `${offer.categoryId}-${offer.tierName}`,
    };
  });

  const flight = data.flightDetails;

  return {
    routeSummary: data.routeSummary || null,
    fleetOffers,
    flightDetails: flight
      ? {
          flightNo: flight.flightNo,
          status: flight.status,
          statusTips: flight.statusTips,
          airline: flight.airline,
          departure: flight.departure
            ? {
                ...flight.departure,
                scheduledFormatted: formatDateTime(flight.departure.scheduled),
                actualFormatted: formatDateTime(flight.departure.actual),
              }
            : null,
          arrival: flight.arrival
            ? {
                ...flight.arrival,
                scheduledFormatted: formatDateTime(flight.arrival.scheduled),
                actualFormatted: formatDateTime(flight.arrival.actual),
              }
            : null,
          recommendedBuffer: (flight.bufferOptions || []).find(
            (opt) => opt.recommend
          ),
        }
      : null,
    flightLandTime: data.flightLandTime
      ? formatDateTime(data.flightLandTime)
      : null,
  };
};

export const getUniqueVendorCount = (fleetOffers = []) =>
  new Set(
    fleetOffers.flatMap((offer) =>
      (offer.availableRates || []).map((rate) => rate.vendorName)
    )
  ).size;
